module.exports = __webpack_public_path__ + "media/images/top-search-bg-9b455466cb90e07b2f8b14e261d03a0d.png";